import { __generator } from "tslib";
import fscreen from 'fscreen';
import get from 'lodash/get';
import { takeLatest, all, call, put, select, takeEvery, fork, race, take, } from 'redux-saga/effects';
import { loadDeviation, togglePanel, showPanel, hidePanel, requestChangeViewMode, fullscreenExited, fullscreenEntered, initDeviationPage, enterZoomMode, exitZoomMode, expandAndFocusCommentPanel, } from './actions';
import { initializeThreadFromPapi, initializeEmptyThread, } from '../../CommentThread/actionCreators';
import { focusEditorWithScroll } from '../../CommentEditor/redux/actionCreators';
import { normalize } from 'normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { putEntities } from '../../redux/entities/actions';
import { actions as collectionActions } from '../../CollectionPanel/redux';
import { getVisiblePanel, getIsTheaterForced, getIsFullscreenAllowed, getBiEventData, } from './selectors';
import { getIsLoggedIn, getViewMode, getIsMobile, } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { setViewMode } from '../../publicSession/actions';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import biLogger from '@wix/da-bi/pkg/BiLogger.logger';
import { getBiEventTypeForViewChange, getDeviationNotificationQueue, getCommentableTypeForDeviationType, } from './helpers';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { exitDuperbrowse, shutdownDuperbrowse, unloadDuperbrowseItem, } from '../../Duperbrowse/redux/actionCreators';
import { logPageView } from '../../biLogger/redux/actions';
import { collectFave } from '../../CollectionPanel/redux/actionCreators';
import { removeQueues } from '../../Notifications/redux/actionCreators';
import { getCommentBoxId } from '../../CommentThread/helpers';
import { pushPopover } from '../../Popovers/redux/actionCreators';
import { PopoverType } from '../../Popovers/redux/types';
import { isDeviation } from '../../Duperbrowse/redux/helpers';
var fsLogger = ddt.createLogger('fullscreen');
function handleLoadDeviation(_a) {
    var _b, view, eventComponent, deviationId, deviationResourceType, isDuperbrowse, contentViewStatus;
    var deviation = _a.payload.deviation;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getBiEventData, deviation)];
            case 1:
                _b = _c.sent(), view = _b.view, eventComponent = _b.eventComponent, deviationId = _b.deviationId, deviationResourceType = _b.deviationResourceType, isDuperbrowse = _b.isDuperbrowse, contentViewStatus = _b.contentViewStatus;
                return [4 /*yield*/, put(logPageView({
                        view: view,
                        component: eventComponent,
                        typeid: deviationResourceType,
                        itemid: deviationId,
                        is_duper: isDuperbrowse ? 1 : 0,
                        content_view_status: contentViewStatus,
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleInitDeviationPage(_a) {
    var entities, isAuthorWatched, author;
    var _b = _a.payload, deviation = _b.deviation, comments = _b.comments;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                entities = normalize(deviation, deviationSchema).entities;
                isAuthorWatched = get(deviation, 'extended.isWatchingAuthor', false);
                author = get(deviation, 'author.username', '');
                return [4 /*yield*/, all([
                        put(comments
                            ? initializeThreadFromPapi(comments)
                            : initializeEmptyThread(deviation.deviationId, getCommentableTypeForDeviationType(deviation.typeId))),
                        put(setWatchingState(author, isAuthorWatched)),
                        put(putEntities({ entities: entities })),
                    ])];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnloadDuperbrowseItem(_a) {
    var deviation = _a.payload.deviation;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!deviation || !isDeviation(deviation)) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(removeQueues(function (queueName) {
                        return queueName.startsWith('deviation') &&
                            queueName !== getDeviationNotificationQueue(deviation);
                    }))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleTogglePanel(_a) {
    var visible, isLoggedIn, referrals;
    var _b = _a.payload, actionBar = _b.actionBar, panelType = _b.panelType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!panelType) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getVisiblePanel, actionBar)];
            case 1:
                visible = _c.sent();
                if (!(visible === panelType)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(hidePanel(panelType))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getIsLoggedIn)];
            case 4:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 6];
                referrals = {
                    collection: ReferralType.FAVOURITE,
                    groups: ReferralType.ADD_TO_GROUP,
                    comment: ReferralType.COMMENT,
                };
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: referrals[panelType] }))];
            case 5:
                _c.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(showPanel(panelType, actionBar))];
            case 7:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleEnterFullscreen() {
    fsLogger.log('Requesting fullscreen');
    fscreen.requestFullscreen(document.documentElement);
}
function handleExitFullscreen() {
    fsLogger.log('Requesting exit fullscreen');
    fscreen.exitFullscreen();
}
function getNextViewMode(currentViewMode, requestedViewMode, deviation) {
    var isTheaterStateForced, normalModeIfAllowed, isFullscreenAllowed, nextViewMode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsTheaterForced, deviation)];
            case 1:
                isTheaterStateForced = _a.sent();
                normalModeIfAllowed = isTheaterStateForced
                    ? DeviationViewMode.Theater
                    : DeviationViewMode.Normal;
                return [4 /*yield*/, select(getIsFullscreenAllowed)];
            case 2:
                isFullscreenAllowed = _a.sent();
                switch (currentViewMode) {
                    case DeviationViewMode.Fullscreen:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                            case DeviationViewMode.Normal:
                                nextViewMode = normalModeIfAllowed;
                                break;
                            case DeviationViewMode.Theater:
                                nextViewMode = DeviationViewMode.Theater;
                                break;
                            default:
                        }
                        break;
                    case DeviationViewMode.Theater:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                                if (isFullscreenAllowed) {
                                    nextViewMode = DeviationViewMode.Fullscreen;
                                }
                                break;
                            case DeviationViewMode.Theater:
                            case DeviationViewMode.Normal:
                                nextViewMode = normalModeIfAllowed;
                                break;
                            default:
                        }
                        break;
                    case DeviationViewMode.Normal:
                        switch (requestedViewMode) {
                            case DeviationViewMode.Fullscreen:
                                if (isFullscreenAllowed) {
                                    nextViewMode = DeviationViewMode.Fullscreen;
                                }
                                break;
                            case DeviationViewMode.Theater:
                                nextViewMode = DeviationViewMode.Theater;
                                break;
                            default:
                        }
                        break;
                    default:
                }
                return [2 /*return*/, nextViewMode];
        }
    });
}
function handleRequestChangeViewMode() {
    var _a, requestChange, fsExit, fsEnter, requestedViewMode, deviation, currentViewMode, nextViewMode, _b, view, publicSession, eventComponent, deviationId, event_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                // Because this waits in a while loop, we dont want it on the serverside
                if (typeof window === 'undefined') {
                    return [2 /*return*/];
                }
                _c.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, race({
                        requestChange: take(requestChangeViewMode),
                        fsExit: take(fullscreenExited),
                        fsEnter: take(fullscreenEntered),
                    })];
            case 2:
                _a = _c.sent(), requestChange = _a.requestChange, fsExit = _a.fsExit, fsEnter = _a.fsEnter;
                requestedViewMode = requestChange
                    ? requestChange.payload.viewMode
                    : fsExit
                        ? DeviationViewMode.Normal
                        : fsEnter
                            ? DeviationViewMode.Fullscreen
                            : undefined;
                deviation = get(requestChange || fsExit || fsEnter || {}, 'payload.deviation');
                // this should not happen(tm), but just in case
                if (!requestedViewMode) {
                    return [3 /*break*/, 1];
                }
                fsLogger.log('View mode change requested:', requestedViewMode);
                return [4 /*yield*/, select(getViewMode)];
            case 3:
                currentViewMode = _c.sent();
                return [4 /*yield*/, call(getNextViewMode, currentViewMode, requestedViewMode, deviation)];
            case 4:
                nextViewMode = _c.sent();
                fsLogger.log('Determined target view mode:', nextViewMode);
                // nothing changed, go back to waiting for events
                if (currentViewMode === nextViewMode) {
                    return [3 /*break*/, 1];
                }
                if (!(currentViewMode === DeviationViewMode.Fullscreen && !fsExit)) return [3 /*break*/, 6];
                fsLogger.log('Full screen exit sync start');
                return [4 /*yield*/, all([call(handleExitFullscreen), take(fullscreenExited)])];
            case 5:
                _c.sent();
                fsLogger.log('Full screen exit sync complete');
                return [3 /*break*/, 8];
            case 6:
                if (!(nextViewMode === DeviationViewMode.Fullscreen && !fsEnter)) return [3 /*break*/, 8];
                fsLogger.log('Full screen exit sync start');
                return [4 /*yield*/, all([call(handleEnterFullscreen), take(fullscreenEntered)])];
            case 7:
                _c.sent();
                fsLogger.log('Full screen enter sync complete');
                _c.label = 8;
            case 8:
                if (!(nextViewMode && deviation)) return [3 /*break*/, 11];
                fsLogger.log('Mode change ready', nextViewMode);
                return [4 /*yield*/, select(getBiEventData, deviation)];
            case 9:
                _b = _c.sent(), view = _b.view, publicSession = _b.publicSession, eventComponent = _b.eventComponent, deviationId = _b.deviationId;
                event_1 = {
                    evid: getBiEventTypeForViewChange(currentViewMode, nextViewMode),
                    view: view,
                    component: eventComponent,
                    deviationid: deviationId,
                    viewmode: nextViewMode,
                };
                return [4 /*yield*/, all([
                        put(setViewMode({ currentViewMode: currentViewMode, nextViewMode: nextViewMode })),
                        call([biLogger, 'log'], publicSession, event_1),
                    ])];
            case 10:
                _c.sent();
                _c.label = 11;
            case 11: return [3 /*break*/, 1];
            case 12: return [2 /*return*/];
        }
    });
}
function handleZoomChange(_a) {
    var _b, view, publicSession, eventComponent, deviationId, deviationResourceType, event;
    var deviation = _a.payload.deviation, type = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getBiEventData, deviation)];
            case 1:
                _b = _c.sent(), view = _b.view, publicSession = _b.publicSession, eventComponent = _b.eventComponent, deviationId = _b.deviationId, deviationResourceType = _b.deviationResourceType;
                event = {
                    evid: BiEventType.ZOOM_MODE,
                    view: view,
                    component: eventComponent,
                    typeid: deviationResourceType,
                    deviationid: deviationId,
                    viewmode: type === enterZoomMode.toString() ? 'zoom' : 'regular',
                };
                return [4 /*yield*/, call([biLogger, 'log'], publicSession, event)];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleExitDuperbrowse() {
    if (fscreen.fullscreenElement) {
        fscreen.exitFullscreen();
    }
}
function handleCollectFave(_a) {
    var isLoggedIn;
    var _b = _a.payload, notificationQueue = _b.notificationQueue, actionBarType = _b.actionBarType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!notificationQueue.startsWith('deviation')) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(pushPopover(actionBarType === 'primary'
                    ? PopoverType.ADD_TO_COLLECTION_PRIMARY
                    : PopoverType.ADD_TO_COLLECTION_SECONDARY, {
                    params: { ignorePreselectedCollections: true },
                }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleRequestCollectionPanelClose() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(hidePanel('collection'))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleExpandAndFocusCommentPanel(_a) {
    var isMobile, deviationId, typeId, editorId;
    var _b = _a.payload, deviation = _b.deviation, actionBarType = _b.actionBarType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsMobile)];
            case 1:
                isMobile = _c.sent();
                deviationId = deviation.deviationId, typeId = deviation.typeId;
                if (!!isMobile) return [3 /*break*/, 3];
                return [4 /*yield*/, put(togglePanel('comment', actionBarType))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                editorId = getCommentBoxId(getCommentableTypeForDeviationType(typeId), deviationId, 'top');
                return [4 /*yield*/, put(focusEditorWithScroll(editorId, true))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default function deviationPageSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    fork(handleRequestChangeViewMode),
                    takeLatest(loadDeviation, handleLoadDeviation),
                    takeEvery(initDeviationPage, handleInitDeviationPage),
                    takeEvery(unloadDuperbrowseItem, handleUnloadDuperbrowseItem),
                    takeLatest(collectFave, handleCollectFave),
                    takeEvery(togglePanel, handleTogglePanel),
                    takeEvery([enterZoomMode, exitZoomMode], handleZoomChange),
                    takeEvery([exitDuperbrowse, shutdownDuperbrowse], handleExitDuperbrowse),
                    takeEvery(collectionActions.requestClose, handleRequestCollectionPanelClose),
                    takeEvery(expandAndFocusCommentPanel, handleExpandAndFocusCommentPanel),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map